import { useEffect } from "react";

const AdminRedirect = () => {
    const adminApp = process.env.REACT_ADMIN_APP_URL
    || process.env.REACT_APP_ENV === "development" 
    ? "http://localhost:5173"
    : "https://admins.magyne.com"
  useEffect(() => {
    window.location.href=`${adminApp}/login`;
  }, []);

  return null;
};

export default AdminRedirect;